import React from 'react';
import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import Button from '@ublend-npm/aulaui-next-web/Button';
import CircularProgress from 'material-ui/CircularProgress/CircularProgress';

export const Container = styled('div')`
  min-height: 60px;
  margin-right: -20px;
  width: 100%;
  padding: 32px 24px 22px 24px;
  box-sizing: border-box;
`;

export const TopRow = styled('div')`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  height: auto;
`;

export const AddUsersButton = styled(Button)`
  background-color: ${colors.designSystem.purple70};
  color: ${colors.white};
  padding: ${theme.spacing.small} ${theme.spacing.medium};
  font-weight: ${theme.font.weight.semiBold};
  line-height: 16px;
  min-width: 124px;

  svg {
    opacity: 1;
  }

  &:disabled {
    background-color: ${colors.blackAlpha(0.12)};
    color: ${colors.designSystem.blackOpacity38};
  }

  &:hover {
    background-color: ${colors.designSystem.purple70};
    opacity: 0.86;
  }

  &.addingParticipant {
    background-color: ${colors.designSystem.purple70};
    opacity: 0.92;
  }
`;

export const Loader = styled(() => (
  <CircularProgress color={colors.white} thickness={2} size={20} />
))``;

export const Content = styled('div')`
  box-sizing: border-box;
  width: inherit;
  height: calc(100% - 95px);
`;
